import filter from "./filter"
import prototype from "./prototype"
import host from './serverHost'
import directive from "./directive"
export default{
    server:host,
    filters:filter,
    prototypes:prototype,
    directives:directive
}


// WEBPACK FOOTER //
// ./src/common/config.js